import { Component, Input, OnInit } from '@angular/core';
import formatDistance from 'date-fns/formatDistance';

@Component({
  selector: 'app-application-complete-status',
  templateUrl: './application-complete-status.component.html',
  styleUrls: ['./application-complete-status.component.scss']
})
export class ApplicationCompleteStatusComponent implements OnInit {
  @Input() applicationComplete: string;
  appCompleteTooltip: string | null;

  constructor() { }

  ngOnInit(): void {
    this.appCompleteTooltip = this.applicationComplete ?
      `Online application completed ${formatDistance(new Date(this.applicationComplete), new Date(), { addSuffix: true })}` :
      null;
  }
}
